
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
  Eine andere Studie, die in der medizinischen <Link href='https://www.thelancet.com/journals/landig/article/PIIS2589-7500(20)30026-1/fulltext' allowWordWrap mdxType="Link">Fachzeitschrift «The Lancet»</Link> erschienen ist, zeigt ebenfalls, dass vor allem ältere Personen ein erhöhtes
  Sterberisiko haben und Kinder deutlich weniger. Das mittlere Alter der an
  Covid-19 Verstorbenen wurde dort mit 70 Jahre angegeben.
    </p>
    <p>
  Manuel Battegay, Chefarzt der Klinik Infektiologie & Spitalhygiene am
  Universitätsspital Basel, schätzt das Sterberisiko so ein: «Daten zeigen,
  dass ungefähr die Hälfte der Verstorbenen weitere Erkrankungen wie Diabetes
  oder einen hohen Blutdruck aufweisen. Aber umgekehrt waren auch 30 Prozent bis
  50 Prozent der Verstorbenen gesund. Die obige chinesische Studie zeigt, dass
  das Sterblichkeitsrisiko ab 65 Jahren stark ansteigt.»
    </p>
    <p>
  Obwohl es viele milde Verläufe von Covid-19 gibt, bleibt die Gefährlichkeit des
  Virus dennoch hoch. Denn auch wenn die Sterblichkeit wegen der Anzahl leichter
  Fälle, die nicht bekannt wurden und als Dunkelziffer gelten, auf 1 Prozent sinken
  würde, ist diese deutlich höher als bei der Grippe mit 0,02 bis 0,3 Prozent.
  Influenzafälle gibt es pro Jahr weltweit bis zu 900 Millionen, dabei sterben
  200'000 bis 650'000 Personen.
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;